export default __webpack_public_path__ + "final-cut-pro-x.e18121cf.png";